import TeamHeader from './TeamHeader';

export default TeamHeader;
